import { render, staticRenderFns } from "./SelectRelationship.vue?vue&type=template&id=39aea720&"
import script from "./SelectRelationship.vue?vue&type=script&lang=js&"
export * from "./SelectRelationship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports